/**
 * Parsing HTML response
 *
 * @param  {Object} response - HTTP request
 * @return {String} - parsed response
 */
export default function parseHtmlResponse(response) {
  if (response.status === 204) return {};
  return response.text().catch(function () {});
}